export default __webpack_public_path__ + "static/media/goodSmiley.bf4c975f.svg";